import React from 'react'
import { RefreshIcon } from '@heroicons/react/outline'

const WaitingText = () => {
  return (
    <div className="flex items-center gap-2">
      <span>Tunggu...</span>
      <RefreshIcon className="w-5 h-5 animate-reverse-spin" />
    </div>
  )
}

export default WaitingText